// eslint-ignore
export default 
`<template>
  <div>
    <label class="text-sm mb-1 text-gray-500">Splash Message Title</label>
    <b-form-input v-model="title" class="w-50 mr-2 mb-3"></b-form-input>

    <label class="text-sm mb-1 text-gray-500">Splash Message Description</label>
    <b-form-input v-model="description" class="w-50 mr-2 mb-3"></b-form-input>

    <label class="text-sm mb-1 text-gray-500">Splash Message Time</label>
    <b-form-input v-model="time" placeholder="Splash Message Description" class="mr-2 mb-3" style="width: 10%;"></b-form-input>

    <label class="text-sm mb-1 text-gray-500">Splash Message Variants</label>
    <b-form-group label="Splash Message Variants">
      <b-form-radio-group
        v-model="variant"
        :options="variants"
        :aria-describedby="ariaDescribedby"
        name="radio-inline"
      ></b-form-radio-group>
    </b-form-group>
    
    <b-button variant="primary" @click="openSplashMessage()">Open Splash Message</b-button>
    <SplashMessage ref='splashMessage'/>
  </div>
</template>

<script>

export default {
  data () {
    return {
      title: null,
      description: null,
      variant: 'primary',
      time: 5000,
      variants: [
        'primary',
        'success',
        'warning',
        'danger'
      ]
    }
  },
  methods: {
    openSplashMessage () {
      this.$refs.splashMessage.show({
        title: this.title,
        description: this.description,
        variant: this.variant,
        time: this.time
      })
    }
  }
}
</script>`;